import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';


export const LabelWithWrappingContent = ({ label, content }) => {
    const [shouldStack, setShouldStack] = React.useState(false);
    const containerRef = React.useRef(null);
    const textRef = React.useRef(null);

    React.useEffect(() => {
      if (containerRef.current && textRef.current && content) {
        // Create a temporary span to measure label width
        const tempLabelSpan = document.createElement('span');
        tempLabelSpan.style.visibility = 'hidden';
        tempLabelSpan.style.position = 'absolute';
        tempLabelSpan.style.fontWeight = 'bold';
        tempLabelSpan.style.fontSize = window.getComputedStyle(textRef.current).fontSize;
        tempLabelSpan.style.fontFamily = window.getComputedStyle(textRef.current).fontFamily;
        tempLabelSpan.textContent = label;
        
        document.body.appendChild(tempLabelSpan);
        const labelWidth = tempLabelSpan.offsetWidth + 16; // Add margin for spacing
        document.body.removeChild(tempLabelSpan);

        // Create a temporary span to measure text width
        const tempSpan = document.createElement('span');
        tempSpan.style.visibility = 'hidden';
        tempSpan.style.position = 'absolute';
        tempSpan.style.whiteSpace = 'nowrap';
        tempSpan.style.fontSize = window.getComputedStyle(textRef.current).fontSize;
        tempSpan.style.fontFamily = window.getComputedStyle(textRef.current).fontFamily;
        tempSpan.textContent = content;
        
        document.body.appendChild(tempSpan);
        const textWidth = tempSpan.offsetWidth;
        document.body.removeChild(tempSpan);
        
        const containerWidth = containerRef.current.offsetWidth;

        // If text width exceeds available space, stack it below
        setShouldStack(textWidth > (containerWidth - labelWidth));
      }
    }, [content, label]);

    if (shouldStack) {
      return (
        <Box sx={{ mb: 1 }} ref={containerRef}>
          <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
            {label}
          </Typography>
          <Typography
            ref={textRef}
            variant="body2"
            color="text.secondary"
            sx={{
              wordWrap: 'break-word',
              whiteSpace: 'pre-wrap'
            }}
          >
            {content || ''}
          </Typography>
        </Box>
      );
    }
    return (
      <Box
        ref={containerRef}
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'baseline',
          mb: 1
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 'bold', mr: 1 }}>
          {label}
        </Typography>
        <Typography
          ref={textRef}
          variant="body2"
          color="text.secondary"
          sx={{ flex: 1, minWidth: 0, whiteSpace: 'pre-wrap' }}
        >
          {content || ''}
        </Typography>
      </Box>
    );
  };